import { jsx } from 'panel';
import { TooltipEl } from 'common/components/tooltip';
import { ButtonEl } from 'common/components/button';
import { SelectEl } from 'common/components/select';
export function template() {
  const {
    contextPanelTransform
  } = this.state;
  return jsx("div", {
    sel: '.mp-control-bar',
    attrs: {
      elref: "menuItems"
    }
  }, (() => {
    const overflowItems = this.helpers.getOverflowItems();
    return jsx(null, null, this.attr("controls") && this.attr("controls").items.map((section, index) => {
      const {
        isDisabled,
        icon,
        label,
        theme,
        value,
        slot,
        tooltip,
        elref
      } = section;
      return jsx("div", {
        sel: '.mp-control-bar-control'
      }, tooltip ? jsx(TooltipEl, {
        attrs: {
          placement: tooltip.placement,
          'body-level': true,
          text: tooltip.text
        }
      }) : null, slot ? jsx("slot", {
        attrs: {
          name: slot
        }
      }) : jsx(ButtonEl, {
        key: "".concat(index, "-value"),
        attrs: {
          disabled: isDisabled,
          icon,
          value,
          theme: theme || this.attr("theme"),
          elref
        },
        on: {
          click: this.helpers.handleClick
        }
      }, label ? label : null));
    }), overflowItems.length ? jsx("div", {
      sel: '.mp-control-bar-truncated-menu-container'
    }, jsx(SelectEl, {
      attrs: this.helpers.getSelectAttrs(),
      on: {
        change: this.helpers.handleMenuClick
      },
      props: {
        contextPanelTransform
      }
    })) : null);
  })());
}